import { h } from 'vue';
import { VSvgIcon } from 'vuetify/components/VIcon';
import type { IconProps, IconSet } from 'vuetify';
import { mdiPaths } from './mdiIcons';

// Набор иконок под именем mdi: принимает те же строки 'mdi-*', что и вебшрифт,
// но отдаёт их SVG-путями из @mdi/js. Так в бандл попадают только нужные иконки,
// а вызовы в шаблонах и внутри @ismet/vue-ui-kit остаются прежними.
export const mdiSvg: IconSet = {
    component: (props: IconProps) => {
        const name = String(props.icon);
        const path = mdiPaths[name];

        if (!path && import.meta.env.DEV) {
            console.warn(`[icons] нет иконки "${name}" в mdiIcons.ts, запустите: node gen-mdi-icons.mjs`);
        }

        return h(VSvgIcon, { ...props, icon: path ?? '' });
    },
};
